import ROLES from '../../models/roles';

class UserInfoPanelController {
  constructor(AuthenticationService, $state, userAccountService, roleService, SsoAuthorizationService, config) {
    this.name = 'userInfoPanel';
    this.AuthenticationService = AuthenticationService;
    this.$state = $state;
    this.roleService = roleService;
    this.ssoService = SsoAuthorizationService;
    this.config = config;
    this.user = userAccountService.getUserDetailsFromClientStorage();
  }

  logout() {
    //get the value of sso flag from localStorage before we clear it.To make a decision of on the future route.
    const isSsoLaunch = this.isSso();
    this.AuthenticationService.logout();
    if(isSsoLaunch){
      //redirect to the sso login page
      window.location.href = this.config.sso.loginURL;
    }else{
      this.$state.go('login');
    }
  }

  shouldShowStatusIndicator() {
    return this.roleService.looksLikeCustomerAdmin();
  }

  shouldShowProxyingCustomer() {
    return this.roleService.getIsImpersonating();
  }

  isSso() {
    return this.ssoService.getSsoLaunch();
  }

  isImpersonatingAsSupportOrSuperAdmin(){
    const role = this.roleService.getRole();
    const isPrivilegedRole = role === ROLES.SUPER_ADMIN || role === ROLES.SUPPORT_ADMIN || role === ROLES.MHE_ADMIN_ROLE;
    const isImpersonating = this.roleService.getIsImpersonating();
    
    return isPrivilegedRole && isImpersonating;
  }

  backAsSuperAdmin(){
    this.roleService.setIsImpersonating(false);
    this.$state.go('home'); 
  }
}

UserInfoPanelController.$inject = ['AuthenticationService', '$state', 'userAccountService', 'roleService', 'SsoAuthorizationService', 'config'];

export
default UserInfoPanelController;



// WEBPACK FOOTER //
// ./app/components/userInfoPanel/userInfoPanel.controller.js